import { Component, OnInit, inject, output } from '@angular/core';
import { OrderFilter } from 'src/app/common/OrderFilter';
import { OrderService } from 'src/app/services/order.service';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { FilterCardComponent } from '../filter-card/filter-card.component';
import { isDefaultFilter } from 'src/app/common/filter-state';

@Component({
    imports: [DateRangeFilterComponent, FilterCardComponent],
    selector: 'app-order-search',
    templateUrl: './order-search.component.html'
})
export class OrderSearchComponent implements OnInit {
  private orderService = inject(OrderService);

  public filter: OrderFilter = new OrderFilter();

  readonly searchCriteria = output<OrderFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private defaults: OrderFilter = new OrderFilter();

  public get isFiltered(): boolean {
    return !isDefaultFilter({ ...this.filter }, { ...this.defaults });
  }

  public resetFilter(): void {
    this.filter = new OrderFilter(this.defaults.dateFrom, this.defaults.dateTo, this.defaults.customerId);
    this.searchThis();
  }

  searchThis() {
    this.searchCriteria.emit(this.filter);
  }

  ngOnInit(): void {
    this.filter = this.orderService.getDefaultFilter();
    this.defaults = { ...this.filter };
    this.searchCriteria.emit(this.filter);
  }

}
